export function budgetRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_BUDGET_START":           
        case "FETCH_BUDGETS_START":                                 
        case "UPDATE_BUDGET_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_BUDGET_FULFILLED":           
        case "FETCH_BUDGETS_FULFILLED":                                 
        case "UPDATE_BUDGET_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_BUDGET_ERROR":
        case "FETCH_BUDGETS_ERROR":
        case "UPDATE_BUDGET_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}